import * as React from 'react';
import { DashboardViewModel } from '../components/dashboard/dashboard-view';
import useRestService from '../shared/rest-service';
import { AppContext } from '../shared/app-context';
import { useQuery } from '@tanstack/react-query';
import { useClients } from './useClients';

/**
 * useDashboard
 * Custom hook leveraging React Query to cache global API state of currently
 * available clients and dashboards
 */
const useDashboard = () => {
  const { state, setState } = React.useContext(AppContext);
  const { fetchWrapper } = useRestService();

  const clientsQuery = useClients();

  React.useEffect(() => {
    if (clientsQuery.data) {
      const clients = clientsQuery.data.results;
      const currentClientId = state.clientId || clients[0].clientId;
      localStorage.setItem('clientId', currentClientId.toString());

      const activeClient = clients.filter((client) => client.clientId === Number(currentClientId))[0];
      if (activeClient !== undefined) {
        localStorage.setItem('enableServiceDesk', activeClient.enableServiceDesk.toString());
        localStorage.setItem('supportEmail', activeClient.supportEmail);
      }
      setState({
        clientId: currentClientId,
        clientName: activeClient.name,
        enableServiceDesk: activeClient.enableServiceDesk,
        supportEmail: activeClient.supportEmail
      });
    }
  }, [clientsQuery.data]);

  const dashboardsQuery = useQuery<DashboardViewModel, Error>(
    ['dashboards', state.clientId],
    async () => {
      return fetchWrapper(`api/${state.clientId}/dashboards/list`);
    },
    {
      enabled: Boolean(clientsQuery.data && state.clientId)
    }
  );

  return {
    clientsQuery,
    dashboardsQuery
  };
};

export default useDashboard;
